import { DocumentTemplateService } from '@/modules/document-template/document-template-service';
import { DocumentTemplatePermissions } from '@/modules/document-template/document-template-permissions';
import Errors from '@/shared/error/errors';

// action types
export const DO_FETCH = 'doFetch';

// mutation types
export const FETCH_SUCCESS = 'fetchSuccess';
export const SET_CURRENT_PAGE = 'setCurrentPage';
export const SET_FILTERS = 'setFilters';
export const REMOVE_RECORD = 'removeRecord';
export const UPDATE_RECORD = 'updateRecord';

const state = {
    rows: [],
    total: 0,
    storeFilters: {},
    currentPage: 1,
};

const getters = {
    rows: (state) => state.rows || [],
    total: (state) => state.total,
    filters: (state) => state.storeFilters,
    currentPage: (state) => state.currentPage,
    documentTemplatePermissions : (state, getters, rootState, rootGetters) => {
        const currentUser = rootGetters['auth/currentUser'];
        return {
            hasPermissionToEdit: new DocumentTemplatePermissions(currentUser).edit,
            hasPermissionToDestroy: new DocumentTemplatePermissions(currentUser).destroy,
        }
    }
};

const actions = {
    [DO_FETCH](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit('shared/activateLoading', 'documentTemplate/get', { root: true });
            const filters = { params: { ...payload, pagination: true } };
            DocumentTemplateService.list(filters)
                .then((data) => {
                    context.commit(FETCH_SUCCESS, {
                        rows: data.data,
                        total: data?.pagination?.total,
                    });
                    resolve();
                })
                .catch(( error ) => {
                    Errors.handle(error);
                    reject();
                })
                .finally(() => {
                    context.commit('shared/deactivateLoading', 'documentTemplate/get', { root: true });
                });
        });
    }
};

const mutations = {
    [FETCH_SUCCESS](state, payload) {
        state.rows = payload.rows;
        state.total = payload.total;
    },
    [SET_CURRENT_PAGE](state, page) {
        state.currentPage = page;
    },
    [SET_FILTERS](state, { key, value }) {
        state.storeFilters[key] = value;
    },
    [UPDATE_RECORD](state, record) {
        const recordIndex = state.rows.findIndex((el) => el.id === record.id);
        Object.assign(state.rows[recordIndex], { ...record });
    },
    [REMOVE_RECORD](state, id) {
        state.rows = state.rows.filter((el) => el.id !== id);
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
